import type { StoryCoverLayout } from '@/features/publicsite/types/content/StoryCoverLayout';

/** The three layouts storyCoverLayout chooses between — the union is StoryCoverLayout. */
export const STORY_COVER = {
  media: 'media',
  chip: 'chip',
  pending: 'pending',
} as const;

/**
 * What a story page shows where its cover goes: the picture with the category on it (`media`), the
 * category alone over the title (`chip`) — or `pending`, not known yet, while the page holds back.
 *
 * An uploaded cover is known to exist. The slug convention (/img/news/{slug}.jpg) is only a guess,
 * and most stories have no such file: laying out a 16:9 frame for it opened those pages with a hole
 * that collapsed a moment later, the text jumping up by the height of a picture; laying it out only
 * once the picture had loaded made every story that does have one jump down instead. So whether the
 * file exists is asked (imageExists) while the story itself is on its way, and the page is laid out
 * once, already knowing. A picture that then fails to load (`failed`) still leaves the chip.
 */
export function storyCoverLayout(
  hasUploadedCover: boolean,
  legacyCover: boolean | null,
  failed: boolean,
): StoryCoverLayout {
  if (failed) return STORY_COVER.chip;
  if (hasUploadedCover || legacyCover === true) return STORY_COVER.media;
  if (legacyCover === false) return STORY_COVER.chip;
  return STORY_COVER.pending;
}
